var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 808",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M871.314 748.304C741.587 843.651 412.59 810.432 294.821 748.304C177.051 686.176 1.5779e-05 627.509 -1.14103e-05 240.358C2.24355e-05 -146.793 381.107 27.1534 537.435 123.488C693.762 219.823 908.08 385.615 969.355 457.186C1030.63 528.758 1001.04 652.957 871.314 748.304Z",
    className: "Svg-fill-color"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.a2cb3ca4c769d73ddb791f2e776b1d45.svg";
export { ForwardRef as ReactComponent };